__turbopack_context__.v({
  "container": "styles-module__ohw_dG__container",
  "header": "styles-module__ohw_dG__header",
  "section": "styles-module__ohw_dG__section",
  "stepCard": "styles-module__ohw_dG__stepCard",
  "stepContent": "styles-module__ohw_dG__stepContent",
  "stepIconWrapper": "styles-module__ohw_dG__stepIconWrapper",
  "stepItem": "styles-module__ohw_dG__stepItem",
  "stepsList": "styles-module__ohw_dG__stepsList",
});
